<template>
  <v-layout align-start justify-center class="my-10" mx-0 row wrap>
    <v-flex xs2 sm2 md3 v-if="$vuetify.breakpoint.mdAndUp" id="panel">
      <v-card class="mr-3" tile>
        <v-list-item three-line>
          <v-list-item-content>
            <div class="mb-4">
              <strong>Crédito Nómina</strong>
            </div>
            <v-list-item-title class="mb-1">
              <p>
                <a
                  href="#personal"
                  v-smooth-scroll="{
                    duration: 1000,
                    offset: -100,
                    container: '',
                    updateHistory: false,
                  }"
                  style="text-decoration: none; cursor: pointer;"
                  @click="panel = [1]"
                  >PERSONAL DE NÓMINA</a
                >
              </p>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-flex>
    <v-flex xs10 sm10 md9 id="expansion-pannel_right">
      <v-expansion-panels mandatory multiple v-model="panel">
        <v-expansion-panel>
          <v-expansion-panel-header id="personal">
            <h2>
              <strong>Crédito personal de nomina</strong>
            </h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-layout align-center justify-center row wrap>
              <v-flex xs12 sm12 md6>
                <v-layout justify-center align-center class="primary_dark">
                  <v-flex xs11 sm10>
                    <h3 class="white--text my-12 text-uppercase">
                      {{ title3 }}
                    </h3>
                    <ul>
                      <li
                        class="white--text my-8 font-weight-bold"
                        v-for="(item, index) in items2"
                        :key="index"
                      >
                        {{ item.message }}
                      </li>
                    </ul>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex align-self-start xs12 sm12 md6>
                <v-layout justify-center align-center>
                  <v-flex xs11 sm10>
                    <h3 class="primary_dark--text text-uppercase my-11">
                      {{ title2 }}
                    </h3>
                    <ul>
                      <li
                        class="primary_dark--text my-8 font-weight-bold"
                        v-for="(item, index) in items4"
                        :key="index"
                      >
                        {{ item.message }}
                      </li>
                    </ul>
                    <div
                      class="justify-start my-4"
                      style="color: #1a5c96;font-size: 0.8rem;"
                    >
                      Todos los contratos de nuestros productos, se encuentran
                      debidamente registrados ante la CONDUSEF, en el RECA y
                      pueden ser consultados en las siguientes páginas
                      oficiales:<br />
                      <a
                        style="color: #1a5c96;font-weight: bold;"
                        href="https://www.gob.mx/condusef/"
                        target="_blank"
                        >https://www.gob.mx/condusef/</a
                      >
                      <br />
                      <a
                        style="color: #1a5c96;font-weight: bold;"
                        href="https://phpapps.condusef.gob.mx/reca/_index.php"
                        target="_blank"
                        >https://phpapps.condusef.gob.mx/reca/_index.php</a
                      >
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-flex>
    <v-dialog
      :fullscreen="$vuetify.breakpoint.smAndDown"
      v-model="dialog"
      persistent
      max-width="700px"
    >
      <v-card>
        <v-card-title class="pb-0">
          <v-container class="pb-0">
            <p class="primary--text">Pre-solicitud de Crédito</p>
          </v-container>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field label="Nombre completo *"></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field label="Correo electronico *"></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field label="Direccion del negocio * "></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field label="Colonia *"></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field label="Cuidad o localidad *"></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field label="Código postal *"></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12">
                <v-text-field
                  v-mask="'(###)-###-####'"
                  label="Telefono con lada *"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12">
                <v-autocomplete
                  :items="[
                    'Abarrotes',
                    'Carniceria',
                    'Constructora',
                    'Consultorios médicos',
                    'Dulcerías',
                    'Electronica y Computo',
                    'Farmacias',
                    'Fotografia (estudio)',
                    'Fruterías',
                    'Hoteles y Moteles',
                    'Imprentas y editoriales',
                    'Joyeria y relojeria',
                    'Laboratorios clínicos',
                    'Librerias',
                    'Madererías',
                    'Marisquerías',
                    'Mueblería',
                    'Panaderias',
                    'Purificadora de agua',
                    'Refaccionaria',
                    'Restaurante',
                    'Rosticeria',
                    'Talleres',
                    'Telefonia',
                    'Tortillerias',
                    'Videoclub',
                    'Vinos y licores',
                    'Otro comercio o negocio',
                  ]"
                  label="Giro de su negocio * "
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
          <small>*indica el campo requerido</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary_dark" text @click="dialog = false"
            >Enviar solicitud</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<style scoped></style>
<script>
import { mask } from "vue-the-mask";
export default {
  props: ["image"],
  directives: {
    mask,
  },
  mounted() {
    var el = document.getElementById("panel");
    var el2 = document.getElementById("expansion-pannel_right");
    var elTop =
      el.getBoundingClientRect().top -
      document.body.getBoundingClientRect().top;

    window.addEventListener("scroll", function() {
      if (document.documentElement.scrollTop > elTop - 100) {
        el.style.position = "fixed";
        el.style.top = "115px";
        el.style.left = "0";
        el2.classList.add("offset-md-3");
      } else {
        el.style.position = "static";
        el.style.top = "auto";
        el.style.top = "auto";
        el.style.left = "auto";
        el2.classList.remove("offset-md-3");
      }
    });
  },
  data() {
    return {
      panel: [0],
      title3: "Requisitos para reestructura de crédito",
      dialog: false,
      title2: "Condiciones Crediticias:",
      items: [
        {
          message:
            "Identificación oficial vigente (INE, PASAPORTE O CÉDULA PROFESIONAL).",
        },
        {
          message: "CURP.",
        },
        {
          message: "Comprobante de domicilio vigente (No mayor a 90 días).",
        },
        {
          message:
            "Constancia laboral realizada por recursos humanos que especifique que es basificado no mayor a 30 días naturales.",
        },
        {
          message: "Los últimos 4 recibos de nómina.",
        },
        {
          message: "Estado de cuenta bancario de la nómina (Últimos 3 meses).",
        },
      ],
      ////////////////////////////////////////////////////////////////////////////////////////////////////

      /////////////////////////////////////////////////////////////////////////////////////////////////////
      items3: [
        {
          message: "Plazo: 6, 12, 18 y 24 meses.",
        },
        {
          message: "Pagos quincenales y mensuales vía nómina.",
        },
      ],
      //////////////////////////////////////////////////////////////////////////////////////////////////////////
      items2: [
        {
          message:
            "Antigüedad de 1 año en caso de laborar en Tepic, 2 años en municipios de Nayarit y 3 años en Puerto Vallarta y Bahía de Banderas.",
        },
        {
          message:
            "Identificación oficial vigente (INE, PASAPORTE O CÉDULA PROFESIONAL).",
        },
        {
          message: "CURP",
        },
        {
          message: "Comprobante de domicilio vigente (No mayor a 90 días).",
        },
        {
          message: "Constancia laboral realizada por recursos humanos.",
        },
        {
          message: "4 últimas nóminas.",
        },
      ],
      items4: [
        { message: "Plazo: 6, 12, 18 y 24 meses." },
        {
          message: "Descuentos vía nómina.",
        },
        {
          message: "Tasa de interes desde el 29% anual mas IVA",
        },
        {
          message: "Comisión por apertura desde el 2% mas Iva",
        },
      ],
      items5: [
        { message: "Plazo: 6, 12, 18, 24 y 36 meses." },
        { message: "Tasa de interés desde el 50% anual." },
        { message: "4% de comisión por apertura." },
        {
          message: "Descuento domiciliado a tu tarjeta de nómina.",
        },
      ],
    };
  },
};
</script>
